// People and organisation (/org...), the Organisation area: the org tree,
// units (with their tabs), the register, and the settings (the gear). All in
// the app shell; the section's areas are in the header (OrgShell).
// Settings > quarters is in areas/collab.
import { extra, moved, page, type AreaRoute } from "../../routes/types";

const unitPage = page(() => import("./pages/UnitPage"), "UnitPage");
const settingsPage = page(() => import("./pages/WorkforceSettingsPage"), "WorkforceSettingsPage");

export const routes: AreaRoute[] = [
  extra("/org", page(() => import("./pages/OrgTreePage"), "OrgTreePage")),
  extra("/org/units/:unitId", unitPage),
  // Unit tabs: People · {collabLabelPlural} · Plan (the unit's OGSM, editable there) · Workload.
  extra("/org/units/:unitId/people", unitPage),
  extra("/org/units/:unitId/collabs", unitPage),
  extra("/org/units/:unitId/plan", unitPage),
  extra("/org/units/:unitId/workload", unitPage),
  extra("/org/people", page(() => import("./pages/PeoplePage"), "PeoplePage")),
  extra("/org/people/:employeeId", page(() => import("./pages/EmployeeDetailPage"), "EmployeeDetailPage")),
  extra("/org/settings", settingsPage),
  extra("/org/settings/kinds", settingsPage),
  extra("/org/settings/scales", settingsPage),
  moved("/org/units/:unitId/ogsm", "/org/units/:unitId/plan"),
];
